import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {FastAPIServiceError} from '@chekin/core';

const API_DETAIL_KEY: Record<string, string> = {
  'email already registered': 'auth.error.email_already_registered',
  'invalid credentials': 'auth.error.invalid_credentials',
  'user not found': 'auth.error.user_not_found',
  'invalid code': 'auth.error.invalid_code',
  'code expired': 'auth.error.code_expired',
  'too many requests': 'auth.error.too_many_requests',
};

function getApiDetail(error: FastAPIServiceError): string {
  const detail = Array.isArray(error?.detail) ? error.detail[0]?.msg : error?.detail;

  return detail || error?.message || '';
}

export function useAuthErrorMessage() {
  const {t} = useTranslation();

  return useCallback(
    (error: FastAPIServiceError, fallbackKey: string) => {
      const detail = getApiDetail(error);
      const mappedKey = API_DETAIL_KEY[detail.trim().toLowerCase()];

      if (mappedKey) return t(mappedKey);

      return detail || t(fallbackKey);
    },
    [t],
  );
}
